module.exports = "/images/Icon industry-GoKart.svg?ad0e8e3b44a92a90967df24c616452f2";